import React, { ReactElement } from 'react';

export enum FormattingKeys {
    FORGOTTEN_PASSWORD_LINK = 'FORGOTTEN_PASSWORD_LINK',
    TELEPHONE_NUMBER = 'TELEPHONE_NUMBER',
}

type FormattedStringProps = {
    string: string;
    constant: string;
    element: ReactElement;
};

export function FormattedString({ string, constant, element }: FormattedStringProps): ReactElement {
    const parts = string.split(constant);

    return (
        <>
            {parts[0]}
            {element}
            {parts[1]}
        </>
    );
}
